import { ReactNode } from 'react';
import { MenuItem, SelectInputField } from '@shared/components';
import { EditableValue } from './EditableValue';

interface Props<T extends string> {
  editable: boolean;
  renderValue: () => ReactNode;
  onSave: (value: T) => void;
  defaultValue: T;
  options: MenuItem[];
}

export const EditableSelectValue = <T extends string>({
  editable,
  renderValue,
  onSave,
  defaultValue,
  options,
}: Props<T>) => (
  <EditableValue
    editable={editable}
    renderValue={renderValue}
    defaultValue={defaultValue}
    buttonsPlacement="bottomRight"
    onSave={onSave}
    renderInput={({ value, onChange }) => (
      <SelectInputField
        value={value}
        onChange={(event) => onChange(event.target.value as T)}
        size="small"
        margin="none"
        menuItems={options}
        required
      />
    )}
  />
);
